export default __webpack_public_path__ + "static/media/login.beb9b20e.png";